<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <div class="purchase-course">
        <div class="purchase-course-main">
          <div class="purchase-course-item">
            <h3 class="title">订单提交成功，请尽快付款</h3>
            <p class="order-id">订单号: {{order_num}}</p>
            <div class="tips-box">
              <span class="tips-txt">请在<b>{{minute}}分{{second}}</b>秒内完成支付，否则系统将自动取消此订单</span>
              <span class="money">{{price}}<b>元</b></span>
            </div>
          </div>
          <div class="purchase-course-item">
            <h3 class="pay-method"><i><img src="../../static/images/syy-images/open-icon.png"
                                           width="100%"></i>微信支付</h3>
            <div class="pay-method-icon">
              <a href="javascript:;" :class="{'syy-bordercolor':nowIndex==1}">
                <img :src="urlEwm" width="130">
              </a>
            </div>
          </div>
          <div class="problem">
            <h3>付款遇到问题：</h3>
            <p>付款遇到问题，请您联系客服，我们会第一时间为您处理，客服联系电话：{{tel}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="popul" v-show="popul">
      <div class="popul-text">
        <p>订单已失效，如需购买请重新下单</p>
        <span @click="trueFun">确定</span>
      </div>
    </div>
    <div class="popul" v-show="orderStatus!==0">
      <div class="popul-text">
        <p>已成功购买</p>
        <span @click="orderDetail(id)">确定</span>
      </div>
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import navCom from '../components/welcome-nav'
  import footerCom from '../components/foot'
  import tool from '../assets/js/tool'
  import axios from 'axios'

  export default {
    name: "purchase-course",
    components: {
      navCom,
      footerCom
    },
    data() {
      return {
        navActive: Number,
        userNav: 9,
        order_id: this.$route.query.order_id,//订单ID
        minutes: 0,
        seconds: 0,//秒
        tipShow: false,//弹窗禁用状态
        order: {},//订单数据
        nowIndex: '',
        order_num: this.$route.query.order_num,//订单编号
        Course_Online: Object,//课程信息
        popul: false,//订单取消
        tel: '',
        price: '',
        orderStatus: 0,
        urlEwm: '',//二维码生成图片
        tStatus: null, //定时器
        id:''
      }
    },
    computed: {
      isShowLogin() {
        return this.$store.state.loginShow;
      },
      second() {
        return this.num(this.seconds)
      },
      minute() {
        return this.num(this.minutes)
      },
    },
    methods: {
      payFun() {
        this.$router.push({
          path: `/newfreeCourseDetails`,
        });
      },
      num(n) {
        return n < 10 ? '0' + n : '' + n
      },
      add() {
        var _this = this
        var time = window.setInterval(function () {
          if (_this.seconds === 0 && _this.minutes !== 0) {
            _this.seconds = 59
            _this.minutes -= 1
          } else if (_this.minutes <= 0 && _this.seconds <= 0) {
            _this.minutes = 0;
            _this.seconds = 0;
            _this.popul = true;
            _this.seconds = 0;
            window.clearInterval(time)
          } else {
            _this.seconds -= 1
          }
        }, 1000)
      },
      trueFun() {
        this.popul = false;
        this.$router.push({
          path: '/user/userOrder',
          query: {
            order_num: this.order_num,
            order_status: 2
          }
        });
      },
      orderDetail: function (id) {
        this.$router.push({
          path: '/order-payment-detail',
          query: {
            order_id: id,
            order_status: 1,
            order_num: this.order_num
          },
        });
      },
      /***查看订单详情*/
      getData: function () {
        let data = {
          user_id: this.$store.state.uuid,
          order_num: this.order_num,
        };
        tool.postData('Center_Order/getOrderInfo', data, (res) => {
          this.order_num = res.data.data.order_num;
          this.tel = res.data.data.tel;
          this.price = res.data.data.price;
          this.order_id = res.data.data.id;
          let nowTimestamp = Date.parse(new Date()); //当前时间
          let createdAt = Date.parse(new Date(res.data.data.create_time * 1000)); //订单生成时间
          let endAt = Date.parse(new Date(res.data.data.order_end_time * 1000)); //订单生成时间
          let seconds = endAt - createdAt; //待支付15分钟超时间
          let timeout = (createdAt + seconds - nowTimestamp) / 1000;
          this.minutes = parseInt(timeout / 60);
          this.seconds = parseInt(timeout % 60);
          // console.log(nowTimestamp,createdAt,timeout,seconds)
        })
      },
      /*支付*/
      payment() {
        let that = this;
        let data = {
          order_num: this.order_num,
        };
        axios.post('/api/Wxpay/createOrder', data)
          .then(function (res) {
            console.log('支付',res)
            var baseUrl =
              "http://heihehd.lc13.lcweb02.cn" !== window.location.href
                ? " http://heihehd.lc13.lcweb02.cn"
                : window.location.host;
            that.urlEwm = baseUrl + "/api/Wxpay/getQrcode?qrcode=" + res.data.url;
            that.tStatus = setInterval(that.getOrderStatus, 5000);
          })
      },
      destroyed(){
        clearInterval(this.tStatus)
      },
      // 支付成功
      getOrderStatus() {
        let that = this;
        var num = 1;
        // console.log(num++);
        let data = {
          user_id: this.$store.state.uuid,
          order_num: this.order_num,
        };
        axios.post('/api/Center_Order/checkOrderStatus', data)
          .then(function (res) {
            that.orderStatus=res.data.data.order_status;
            that.id=res.data.data.id;
          })
      }
    },
    destroyed(){
     clearInterval(this.tStatus)
    },
    watch: {
      second: {
        handler(newVal) {
          this.num(newVal)
        }
      },
      minute: {
        handler(newVal) {
          this.num(newVal)
        }
      },
      orderStatus:function(o,v){
        if(o!==0){
          clearInterval(this.tStatus);
          this.tStatus=setInterval(()=>{
          },1000)
        }
      },
      '$route':function(o,v){
        this.payment()
      }
    },
    created() {
      this.navActive = this.$route.query.navActive;
      this.payment();
    },
    mounted() {
      this.add();
      this.getData();
      // this.payment();
    },

  }
</script>

<style scoped>
  .all-whole {
    position: relative;
  }

  .pay-method-icon .syy-bordercolor {
    border-color: #109777;
  }

  .purchase-course {
    width: 100%;
    height: 100%;
    background: #f4f4f4;
  }

  .purchase-course-main {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 30px 30px 110px;
    box-sizing: border-box;
  }

  .purchase-course-item {
    border-bottom: 1px solid #e3e3e3;
  }

  .purchase-course-item .title {
    color: #1e1e1e;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 32px;
  }

  .order-id {
    font-size: 16px;
    color: #414141;
    margin-bottom: 19px;
  }

  .tips-box {
    padding-bottom: 46px;
    display: flex;
    justify-content: space-between;
  }

  .tips-txt {
    font-size: 16px;
    color: #414141;
  }

  .tips-txt b {
    color: #cf0000;
    font-weight: 600;
  }

  .money {
    font-size: 30px;
    color: #ff5400;
  }

  .money b {
    font-size: 16px;
    color: #414141;
    margin-left: 12px;
  }

  .pay-method {
    color: #1e1e1e;
    font-size: 18px;
    font-weight: 700;
    margin: 50px 0 32px;
  }

  .pay-method i {
    width: 12px;
    display: inline-block;
    transform: rotate(270deg);
    margin-right: 10px;
  }

  .pay-method span {
    font-size: 14px;
    color: #898989;
    font-weight: 500;
    margin-left: 10px;
  }

  .pay-method-icon {
    padding-bottom: 36px;
  }

  .pay-method-icon a {
    width: 165px;
    height: 165px;
    border: 1px solid #e3e3e3;
    display: inline-block;
    margin-right: 40px;
    box-sizing: border-box;
    text-align: center;
  }

  .pay-method-icon a img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .payment-btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 235px;
  }

  .payment-btn a {
    width: 213px;
    height: 48px;
    display: inline-block;
    background: #ff9919;
    color: #fff;
    text-align: center;
    line-height: 48px;
    font-size: 20px;
    border-radius: 5px;
    cursor: pointer;
  }

  .problem {
    margin-top: 37px;
  }

  .problem h3 {
    color: #0b0b0b;
    font-size: 16px;
    margin-bottom: 32px;
    font-weight: 600;
  }

  .problem p {
    color: #858585;
    font-size: 14px;
  }

  .popul {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }

  .popul-text {
    background-color: #fff;
    position: fixed;
    width: 350px;
    height: 150px;
    top: 35%;
    left: 40%;
    padding: 20px;
    box-sizing: border-box;
    font-size: 20px;
  }

  .popul-text span {
    margin-top: 50px;
    display: block;
    float: right;
    background-color: #1a71ff;
    color: #fff;
    padding: 10px 15px;
    border-radius: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/payment.vue